import { useState, useCallback } from 'react';
import { useAuthContext } from '../hooks/useAuth';
import { useHistory } from 'react-router-dom';

const NewPatient = () => {
  const history = useHistory();
  const initialFormState = {
    clinic_name: '',
    username: '',
    clinic_phone: '',
    clinic_addr1: '',
    clinic_addr2: '',
    clinic_city: '',
    clinic_state: '',
    clinic_zip: '',
    clinic_email: '',
  };
  const [isSending, setIsSending] = useState(false);
  const [formState, setFormState] = useState(initialFormState);
  const [error, setError] = useState(true);
  const { token } = useAuthContext();

  const handleFormStateChange = ({ name, value }) => {
    const formStateCopy = Object.assign({}, formState);
    formStateCopy[name] = value;
    setFormState(formStateCopy);
  };

  // useCallback example taken from https://stackoverflow.com/questions/55647287/how-to-send-request-on-click-react-hooks-way
  const sendRequest = useCallback(async () => {
    async function submitNewClinic() {
      await fetch('/hadi/add_clinic', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify(formState),
      })
        .then((res) => {
          if (res.status !== 200) {
            setError(res.statusText);
          } else {
            setError('');
            alert('successfully submitted!');
          }
        })
        .catch((error) => {
          setError(error);
          console.error('There was an error!', error);
        });
      setIsSending(false);
    }
    // don't send again while we are sending
    if (isSending) return;
    // update state
    setIsSending(true);
    // send the actual request
    await submitNewClinic();
  }, [isSending, formState]); // update the callback if the state changes

  const handleSubmit = async (e) => {
    e.preventDefault();
    await sendRequest();
  };

  const hasError = !!(error && error.length);

  return (
    <div className="container login-container">
      <div className="row">
        <div className="col-md-6 offset-md-3 login-form">
          <h3>Register a new HADI Clinic</h3>
          <form className="main-form">
            <div className="form-group">
              <input
                type="text"
                name="clinic_name"
                className="form-control"
                placeholder="Clinic Name"
                value={formState['clinic_name']}
                onChange={(e) => handleFormStateChange(e.target)}
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="username"
                className="form-control"
                placeholder="Username"
                required
                value={formState['username']}
                onChange={(e) => handleFormStateChange(e.target)}
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                name="password"
                className="form-control"
                placeholder="Password"
                required
                value={formState['password']}
                onChange={(e) => handleFormStateChange(e.target)}
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="clinic_phone"
                className="form-control"
                placeholder="Phone Number"
                required
                value={formState['clinic_phone']}
                onChange={(e) => handleFormStateChange(e.target)}
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="clinic_addr1"
                className="form-control"
                placeholder="Address Line 1"
                required
                value={formState['clinic_addr1']}
                onChange={(e) => handleFormStateChange(e.target)}
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="clinic_addr2"
                className="form-control"
                placeholder="Address Line 2"
                required
                value={formState['clinic_addr2']}
                onChange={(e) => handleFormStateChange(e.target)}
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="clinic_city"
                className="form-control"
                placeholder="City"
                required
                value={formState['clinic_city']}
                onChange={(e) => handleFormStateChange(e.target)}
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="clinic_state"
                className="form-control"
                placeholder="State"
                required
                value={formState['clinic_state']}
                onChange={(e) => handleFormStateChange(e.target)}
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="clinic_zip"
                className="form-control"
                placeholder="Postal Code"
                required
                value={formState['clinic_zip']}
                onChange={(e) => handleFormStateChange(e.target)}
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="clinic_email"
                className="form-control"
                placeholder="Email ID"
                required
                value={formState['clinic_email']}
                onChange={(e) => handleFormStateChange(e.target)}
              />
            </div>

            {/* <div className="invalid-feedback">Please try again.</div> */}

            <button onClick={handleSubmit} className="btn btn-primary w-100">
              {isSending ? (
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                'Register New Clinic'
              )}
            </button>
            {hasError && <div className="text-danger">{error}</div>}
            <button
              onClick={() => history.goBack()}
              className="btn btn-secondary w-100 mt-3"
            >
              Cancel
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewPatient;
